import { ReportType } from "../../../types/types";
import { api } from "../api";

/**
 * gerenatePositionsHeatMapByVehicleResponse - Function that finds on database an list of positions of vehicles to show it on the heat map
 * /reports/maps/heatmap  
 * method POST 
 * @async-function
 */
const gerenatePositionsHeatMapByVehicleResponse = async (token: string, model: ReportType) => {
    const response = await api.post(
        `/reports/maps/heatmap`, { ...model }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default gerenatePositionsHeatMapByVehicleResponse;